let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9e3Ob")).then(() => parcelRequire('3rV3A'));